import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-preview-image-dialog',
  standalone: false,
  templateUrl: './preview-image-dialog.component.html',
})
export class PreviewImageDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) readonly data: string,
    public readonly dialogRef: MatDialogRef<PreviewImageDialogComponent, void>,
  ) {}
}
